import { BasePage } from '@/components/ui/base-page'

export function InfrastructurePage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add InfrastructurePage specific content here */}
    </BasePage>
  )
}